import useSocket from "hooks/useSocket";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  SOCKET_SERVER_NAMESPACES,
  REPORT_PRESENCE_SOCKET_HEARTBEAT_INTERVAL,
} from "static/constants";

const useReportUserPresence = ({ reportId }) => {
  const socket = useSocket(SOCKET_SERVER_NAMESPACES.REPORT_PRESENCE);
  const { currentUser } = useSelector((state) => state.auth);
  const [activeUsers, setActiveUsers] = useState([]);

  useEffect(() => {
    if (!socket || !reportId) return;

    const joinReport = () => socket.emit("report:join", { reportId });

    const handlePresenceDetail = (detail) => {
      setActiveUsers(
        detail.filter((user) => user.userId !== currentUser?.userId) || []
      );
    };

    socket.on("report:presence:detail", handlePresenceDetail);
    socket.on("socket:ready", joinReport);

    if (socket.isReady) {
      joinReport();
    }

    const heartbeat = setInterval(() => {
      if (socket.isReady) {
        socket.emit("report:heartbeat", { reportId });
      }
    }, REPORT_PRESENCE_SOCKET_HEARTBEAT_INTERVAL);

    return () => {
      clearInterval(heartbeat);
      socket.emit("report:leave", { reportId });
      socket.off("report:presence:detail", handlePresenceDetail);
      socket.off("socket:ready", joinReport);
      setActiveUsers([]);
    };
  }, [socket, reportId, currentUser?.userId]);

  return {
    socket,
    activeUsers,
  };
};

export default useReportUserPresence;
